import http from "./http";

//登录 /api/login
function login(username, password, memberRegistrationLinkCode, rememberMe = false) {
    let url = `/api/pcUser/login`;
    const formdata = new FormData();
    formdata.append("username", username);
    formdata.append("password", password);
    formdata.append("rememberMe", rememberMe);
    formdata.append("memberRegistrationLinkCode", memberRegistrationLinkCode);
    return http.post(url, formdata)
}

export function loginMobile(mobile, code, memberRegistrationLinkCode, rememberMe = false) {
    let url = `/api/pcUser/login/mobile`;
    const formdata = new FormData();
    formdata.append("mobile", mobile);
    formdata.append("code", code);
    formdata.append("rememberMe", rememberMe);
    formdata.append("memberRegistrationLinkCode", memberRegistrationLinkCode);
    return http.post(url, formdata)
}


//查看当前登录用户个人信息      /api/login-user/info
function getUserInfo() {
    let url = `/api/pcUser/login-user/info`;
    return http.get(url)
}

//修改个人信息   /pcUser/update/userInfo
function updateUserInfo(nickname) {
    let url = `/api/pcUser/update/userInfo`;
    // const formdata = new FormData();
    // formdata.append("nickname",nickname);

    return http.post(url, {"nickname": nickname})
}

//我的课程  /weChat/applet/course/init/myCourse
function myCourse() {
    let url = `/api/pc/course/init/myCourse`;
    return http.get(url)
}

//  短信验证码          /pcUser/short-message/vcode/{mobile}
function vcode(mobile) {
    let url = `/api/pcUser/short-message/vcode/${mobile}`;
    return http.get(url)
}

//注册时 短信验证码        /pcUser/register/send/code/{mobile}
function registerCode(mobile) {
    let url = `/api/pcUser/register/send/code/${mobile}`;
    return http.get(url)
}

// 修改用户手机  /pcUser/update/userMobile
function updateUserMobile(mobile, code) {
    let url = `/api/pcUser/update/userMobile`;
    return http.post(url, {
        "mobile": mobile,
        "code": code
    })
}

// 修改密码     /pcUser/update/userPassword
function updateUserPassword(oldPassword, newPassword, checkNewPassword, mobile, code) {
    let url = `/api/pcUser/update/userPassword`;
    const formdata = new FormData();
    formdata.append("updateUserPassword", updateUserPassword);
    formdata.append("oldPassword", oldPassword);
    formdata.append("newPassword", newPassword);
    formdata.append("checkNewPassword", checkNewPassword);
    formdata.append("mobile", mobile);
    formdata.append("code", code);

    return http.post(url, formdata)
}

function originalPasswordModify(data) {
    let formData = new FormData();
    formData.append("checkNewPassword", data.checkNewPassword);
    formData.append("newPassword", data.newPassword);
    formData.append("oldPassword", data.oldPassword);
    return http.post('/api/pcUser/update/userPassword/pass', formData)
}

function phoneModifyPasswordModify(data) {
    let formData = new FormData();
    formData.append("newPassword", data.newPassword);
    formData.append("checkNewPassword", data.checkNewPassword);
    formData.append("mobile", data.mobile);
    formData.append("code", data.code);
    return http.post('/api/pcUser/update/userPassword/code', formData)
}

// 修改头像     pcUser/updata/userAvatar
function updateUserAvatar(file) {
    let url = `/api/pcUser/updata/userAvatar`;
    const formdata = new FormData();
    formdata.append("file", file);
    return http.post(url, formdata)
}


// 注册接口  /pcUser/register
function registry(loginName, password, nickname, mobile, code, memberRegistrationLinkCode) {
    let url = `/api/pcUser/register`;
    const formdata = new FormData();
    formdata.append("loginName", loginName);
    formdata.append("password", password);
    formdata.append("nickname", nickname);
    formdata.append("mobile", mobile);
    formdata.append("code", code);
    formdata.append("memberRegistrationLinkCode", memberRegistrationLinkCode);

    return http.post(url, formdata)
}


///退出登录  /api/logout
function logout() {
    let url = `/api/pcUser/logout`;
    return http.get(url)
}

//忘记密码  /pcUser/password/forget
function forgetPassword(loginName, password, mobile, code) {
    let url = `/api/pcUser/password/forget`;
    return http.post(url, {
        "loginName": loginName,
        "password": password,
        "mobile": mobile,
        "code": code,
    })
}

// 获取报名列表   /pc/liveCourseInfo/course/signup/list
function signupList() {
    let url = `/api/pc/liveCourseInfo/course/signup/list`;
    return http.get(url)
}

// 忘记密码时发送手机验证码  /pcUser/forgetpassword/send/code
function forgetPasswordSendCode(loginName, mobile) {
    let url = `/api/pcUser/forgetpassword/send/code`;
    const formdata = new FormData();
    formdata.append("loginName", loginName);
    formdata.append("mobile", mobile);
    return http.post(url, formdata)
}

//登录时发送手机验证码   /pcUser/login/send/code/{mobile}
function loginSendCode(mobile) {
    let url = `/api/pcUser/login/send/code/${mobile}`;
    return http.get(url)
}

//修改密码时发送验证码  /pcUser/edit-password/send/code/{mobile}
function changePassworfSendCode(mobile) {
    let url = `/api/pcUser/edit-password/send/code/${mobile}`;
    return http.get(url)
}

//点击vip链接且已登录状态下获取vip
function getMemberAfterLogin(code) {
    let url = `/api/member/registrationLink/use/${code}`
    return http.post(url)
}

export {
    login,
    getUserInfo,
    logout,
    updateUserInfo,
    myCourse,
    vcode,
    updateUserMobile,
    updateUserPassword,
    registry,
    forgetPassword,
    updateUserAvatar,
    signupList,
    registerCode,
    forgetPasswordSendCode,
    loginSendCode,
    changePassworfSendCode,
    originalPasswordModify,
    phoneModifyPasswordModify,
    getMemberAfterLogin
}
